import { Currency } from "@sso/types";

import { ssoApi } from "..";
import { CacheKeys } from "../cacheKeys";
import { Endpoints } from "../endpoints";

const softwareApi = ssoApi.enhanceEndpoints({ addTagTypes: [CacheKeys.CURRENCY] }).injectEndpoints({
  endpoints: builder => ({
    currencies: builder.query<Currency[], void>({
      query: () => ({ url: `${Endpoints.CURRENCY}` }),
      providesTags: [CacheKeys.CURRENCY],
    }),
  }),
});

export const { useCurrenciesQuery } = softwareApi;
